import React from 'react';
import { useState, useEffect } from 'react';
import './classes/Mentor.css';
import { configData } from "../config";

const Mentor = ({page}) => {
  const app_url = configData.APP_URL;
  const [content, setContent] = useState([]);

useEffect(() => {
//   setContent([
//   {
//     name: 'Larry Lundy',
//     img: 'https://aisiiczsuo.cloudimg.io/v7/https://www.sportsmanagementworldwide.com/sites/default/files/styles/mentor_block_crop/public/pictures/picture-1472-1441814769.jpg?itok=6_KB0Otw',
//     bio: ['Sport & Athlete Branding Specialist'],
//     link: "#"
//   },
//   {
//     name: 'Dr Lynn Lashbrook',
//     img: 'https://aisiiczsuo.cloudimg.io/v7/https://www.sportsmanagementworldwide.com/sites/default/files/styles/mentor_block_crop/public/pictures/picture-1472-1441814769.jpg?itok=6_KB0Otw',
//     bio: ['SMWW President & Founder', 'Certified NFL Agent', 'Former NCAA Athletic Director'],
//     link: "#"
//   }
// ]);
if(page?.nid) {
getmentors(page.nid);
}
}, [page]);
 const getmentors = async (nid) => {
    try {
     
      const postData = {
           nid: nid,
           
          };
          try {
            const response = await fetch(app_url + 'coursepages/getmentors', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
              setContent(data.data.result);
            }
          } catch (err) {
             
        }
      
      
    } catch (err) {
      console.error(err);
    }
};
  return (
    <div className="course-mentor-card">
      <h2 className="mentor-header">Mentors</h2>
      <ul className="mentor-list">
        {content.map((mentor, idx) => (
          <li key={idx} className="mentor-item">
            <img src={mentor.img} alt={mentor.name} className="mentor-avatar" />
            <a href={mentor.link} className="mentor-name-link">
              {mentor.name}
            </a>
             <span 
                dangerouslySetInnerHTML={{
                    __html:mentor.bio
                }}
            />
            
          </li>
        ))}
      </ul>
    </div>
  );
};
export default Mentor;